/**
 * Paleta ordenada per sèries dimensionals (àmbits, sectors, escenaris comparables,
 * percentils de referència, eixos, etc.): no implica correcte/incorrecte.
 *
 * Ordre acordat (no repetir fins esgotar la llista en un mateix gràfic):
 * 1 Blau · 2 Violeta · 3 Cian fosc · 4 Taronja suau · 5 Magenta · 6 Índigo · 7 Blau petroli · 8 Porpra fosc
 */
export const CHART_DIMENSION_PALETTE = [
  "#2563EB",
  "#7C3AED",
  "#0891B2",
  "#F59E0B",
  "#DB2777",
  "#4F46E5",
  "#0E7490",
  "#9333EA",
] as const;

/** Colors addicionals compatibles si cal més sèries (evitant verd/vermell semàfor). */
export const CHART_DIMENSION_PALETTE_EXTRA = [
  "#1D4ED8",
  "#5B21B6",
  "#0369A1",
  "#C2410C",
  "#9D174D",
] as const;

export const CHART_DIMENSION_ALL = [
  ...CHART_DIMENSION_PALETTE,
  ...CHART_DIMENSION_PALETTE_EXTRA,
] as const;

/** Sistemes territorials (mateix color a tota la plataforma quan es comparen sistemes). */
export const CHART_SISTEMA_CAT = CHART_DIMENSION_PALETTE[0];
export const CHART_SISTEMA_ES = CHART_DIMENSION_PALETTE[1];
export const CHART_SISTEMA_EU = CHART_DIMENSION_PALETTE[2];

/** Semàfor explícit: correcte / intermig / incorrecte */
export const CHART_SEMANTIC_CORRECT = "#16A34A";
export const CHART_SEMANTIC_INCORRECT = "#DC2626";
export const CHART_SEMANTIC_MODERATE = "#F59E0B";

export function chartDimensionColorAt(index: number): string {
  const palette = CHART_DIMENSION_ALL;
  const i = ((index % palette.length) + palette.length) % palette.length;
  return palette[i] as string;
}

/**
 * Paleta per a moltes sèries alhora (p. ex. subsectors de serveis a P2): tons separats
 * al voltant del cercle cromàtic però dins la mateixa família “dashboard” (sense verd/vermell semàfor).
 */
export const CHART_DISTINCT_SERIES_PALETTE = [
  "#2563EB",
  "#EA580C",
  "#7C3AED",
  "#0E7490",
  "#CA8A04",
  "#DB2777",
  "#4F46E5",
  "#0891B2",
  "#C2410C",
  "#6366F1",
  "#B45309",
  "#1D4ED8",
  "#86198F",
  "#0369A1",
  "#9F1239",
  "#92400E",
  "#4338CA",
  "#A16207",
] as const;

const DISTINCT_SERIES_STEP = 5;

/**
 * Assigna colors ben diferenciats per a la fila `index` (0,1,2,…): fa servir un salt coprimer
 * respecte a la longitud de la paleta per evitar blocs de tons similars consecutius.
 */
export function chartDistinctSeriesColorAt(index: number): string {
  const palette = CHART_DISTINCT_SERIES_PALETTE;
  const len = palette.length;
  const i = ((index * DISTINCT_SERIES_STEP) % len + len) % len;
  return palette[i] as string;
}
